import dayjs from 'dayjs';

import * as Yup from 'yup';

import { wordCount } from '../utils/helpers';

export const HOW_DID_YOU_HEAR_OPTIONS = [
  { value: 0, label: 'Report-a-pest postcard' },
  { value: 1, label: 'NAQS Calendar' },
  { value: 2, label: 'Top Watch Merchandise' },
  { value: 3, label: 'DAFF – Website' },
  { value: 4, label: 'Signage' },
  { value: 5, label: 'NAQS staff relationship' },
  { value: 6, label: 'FM Radio' },
  { value: 7, label: 'Word of mouth' },
  { value: 8, label: 'Not sure' },
] as const;

export const ImageSchema = Yup.object({
  file: Yup.mixed<File>().required(),
  url: Yup.string().required(),
});

export type ImageData = Yup.InferType<typeof ImageSchema>;

export const POLYGON_PATHS = [
  { lat: -26, lng: 155 },
  { lat: -26, lng: 112.88 },
  { lat: -21.18, lng: 112.88 },
  { lat: -9.06, lng: 131.64 },
  { lat: -9.09, lng: 145.64 },
];

const isCoordinate = (coordinate: string) =>
  /^([-+]?)([\d]{1,2})(((\.)(\d+)(,)))(\s*)(([-+]?)([\d]{1,3})((\.)(\d+))?)$/.test(coordinate);

const isCoordinateInPolygon = (coordinate: string): boolean => {
  if (!isCoordinate(coordinate)) return false;
  const coordinates = coordinate.split(',');
  const lat = parseFloat(coordinates[0]);
  const lng = parseFloat(coordinates[1]);
  const position = new google.maps.LatLng(lat, lng);
  const australiaZone = new google.maps.Polygon({ paths: POLYGON_PATHS });

  return google.maps.geometry.poly.containsLocation(position, australiaZone);
};

export const RiskSchema = Yup.object({
  observationDate: Yup.string()
    .required()
    .label('Observation date')
    .test({
      name: 'date',
      skipAbsent: true,
      test(value: string) {
        const date = dayjs(value, 'YYYY-MM-DD');
        if (!date.isValid()) {
          return this.createError({ message: 'Must be a date' });
        }
        if (dayjs().isBefore(date, 'day')) {
          return this.createError({ message: 'Date must not be in a future' });
        }
        return true;
      },
    }),
  location: Yup.string().required().label('Location coordinates').test({
    name: 'location',
    message: 'Coordinates are outside the defined area',
    skipAbsent: true,
    test: isCoordinateInPolygon,
  }),
  description: Yup.string()
    .required()
    .test({
      name: 'wordCount',
      message: 'Description must not exceed 200 words',
      test(value: string) {
        return !value || wordCount(value) <= 200;
      },
    })
    .label('Describe observation'),
  hasSampleNumber: Yup.boolean(),
  sampleNumber: Yup.string().when('hasSampleNumber', (hasSampleNumber, schema) =>
    hasSampleNumber ? schema.required() : schema,
  ),
  images: Yup.array().of(ImageSchema).label('Photographs'),
  howDidYouHearAboutUs: Yup.number()
    .oneOf(HOW_DID_YOU_HEAR_OPTIONS.map((option) => option.value))
    .label('How did you hear about us'),
  firstName: Yup.string().required().label('First name'),
  lastName: Yup.string().required().label('Last name'),
  contactEmail: Yup.string().email().required().label('Email address'),
  contactPhone: Yup.string().label('Phone number'),
  captcha: Yup.string().required('You must prove you’re not a robot').label('Google reCAPTCHA'),
});

export type RiskData = Yup.InferType<typeof RiskSchema>;
